import { createSlice } from "@reduxjs/toolkit";
import {separateProductAttributes, setNextSelection} from "../product/productSelectionsSlice";
import patternApi from "../../configurator/services/patternApi";
import {
    productDataLoading,
    productDataReceived,
} from "../product/productDataSlice";
import {manageConfiguratorState} from "../configuratorStateSlice";
import {setupSkuExceptionsAndSelections} from "../exceptions/skuExceptionsSlice";
import {setDisabledFields} from "../exceptions/disabledFieldsSlice";
import {normalizeSides} from "../product/patternSelectionsSlice";

export const patternDetailsSlice =  createSlice({
    name: 'patternDetails',
    initialState: {
        patternDetailsLoading: 'idle',
        patternId: "",
        patternsAvailable: [],
        patternCode: "",
        showPatternSideOptions: false,
        groupId: ""
    },
    reducers: {
        patternDetailsLoading(state ,action){
            if(state.patternDetailsLoading == 'idle'){
                state.patternDetailsLoading = 'pending'
            }
        },
        patternIdSet(state, action){
            if(state.patternDetailsLoading == 'pending'){
                state.patternDetailsLoading = 'idle';
                state.patternId = action.payload;
            }
        },
        patternsAvailableSet(state, action){
            if(state.patternDetailsLoading == 'pending'){
                state.patternDetailsLoading = 'idle';
                state.patternsAvailable = action.payload;
            }
        },
        patternCodeSet(state, action){
            if(state.patternDetailsLoading == 'pending'){
                state.patternDetailsLoading = 'idle';
                state.patternCode = action.payload;
            }
        },
        showPatternSideOptionsSet(state, action){
            if(state.patternDetailsLoading == 'pending'){
                state.patternDetailsLoading = 'idle';
                state.showPatternSideOptions = action.payload;
            }
        },
        groupIdSet(state, action){
            if(state.patternDetailsLoading == 'pending'){
                state.patternDetailsLoading = 'idle';
                state.groupId = action.payload
            }
        }

    }
});
export const { patternDetailsLoading, patternIdSet, patternsAvailableSet, patternCodeSet, showPatternSideOptionsSet, groupIdSet } = patternDetailsSlice.actions;

export const setPatternId = (id) => (dispatch, getState) => {
    dispatch(patternDetailsLoading())
    dispatch(patternIdSet(id));
}

export const setPatternsAvailable = (patterns) => (dispatch) => {
    dispatch(patternDetailsLoading());
    dispatch(patternsAvailableSet(patterns));
}

export const getPatternsAvailable = () => async (dispatch, getState) => {
    const patterns = await patternApi.getPatternsAvailable();
    dispatch(setPatternsAvailable(patterns))
}

export const setPatternCode = (value) => (dispatch) => {
    dispatch(patternDetailsLoading());
    dispatch(patternCodeSet(value))
}

export const setGroupId = (value) => dispatch => {
    dispatch(patternDetailsLoading());
    dispatch(groupIdSet(value));
}

export const setPatternDetails = (id, value) => async (dispatch, getState) => {
    const data = await patternApi.getPatternAttributes(id, value);
    const previousCode = getState().patternDetailsReducer.patternCode;
    dispatch(setPatternCode(value));
    dispatch(manageConfiguratorState());
    dispatch(productDataLoading());
    dispatch(setupSkuExceptionsAndSelections(data.product));
    dispatch(productDataReceived(data.product));
    dispatch(setDisabledFields(data.product));
    dispatch(separateProductAttributes(data.product.product_attributes));
    dispatch(normalizeSides());
    if(previousCode == "") {
        dispatch(setNextSelection());
    }
};



const reducer = patternDetailsSlice.reducer;
export default reducer
